module.exports = __webpack_public_path__ + "static/media/levels_2_1.8c523ae4.svg";